import { jsx as _jsx } from "react/jsx-runtime";
import "../../assets/saas/atoms/_alert.scss";
const Alert = ({ customClass, children, type }) => {
    return (_jsx("div", { className: `alert alert--${type} ${customClass ? customClass : ""}`, children: _jsx("div", { className: "alert-content", children: _jsx("p", { children: children }) }) }));
};
export default Alert;
